import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import Pagination from "../wishlist/Pagination"

const HashtagPageFilters = ({ searchParams, setSearchParams, LOWESTDATEALLOWED, defaultDate, total, changePage, limit }) => {

  return <div className="sticky top-10 pt-4 bg-white z-20">
    <div className="flex justify-between">

      <div className="flex h-full">
        <div className="flex items-center px-2 text-lg font-medium">
          <p>Select date range</p>
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker label={"Start"} value={searchParams.get('from') ? dayjs(searchParams.get("from"), 'DD-MM-YYYY') : dayjs(defaultDate)} onChange={newValue => {
            setSearchParams(prev => {
              if (newValue)
                prev.set('from', newValue.format('DD-MM-YYYY'))
              else
                prev.set('from', dayjs(defaultDate).format('DD-MM-YYYY'))
              return prev;
            })
          }}
            minDate={dayjs(LOWESTDATEALLOWED, 'DD-MM-YYYY')}
            maxDate={dayjs(searchParams.get('to') || dayjs(new Date()).format('DD-MM-YYYY'), 'DD-MM-YYYY')}
          />
          <DatePicker label={"End"} value={searchParams.get('to') ? dayjs(searchParams.get("to"), 'DD-MM-YYYY') : dayjs(new Date())} onChange={newValue => {
            setSearchParams(prev => {
              if (newValue)
                prev.set('to', newValue.format('DD-MM-YYYY'))
              else
                return prev;
            })
          }}
            minDate={searchParams.get('from') ? dayjs(searchParams.get('from'), 'DD-MM-YYYY') : dayjs(LOWESTDATEALLOWED, 'DD-MM-YYYY')}
            maxDate={dayjs(new Date())}
          />
        </LocalizationProvider>
        <select value={searchParams.get('geography')} className="min-h-12 mx-2 px-2 rounded"
          onChange={e => {
            setSearchParams(prev => {
              prev.set('geography', e.target.value)
              return prev
            })
          }}
        >
          <option value={'--select--'} disabled>Select Geography</option>
          <option value={'All'}>All geography</option>
          <option value={'Asian'}>Asian</option>
          <option value={'Indian'}>Indian</option>
          <option value={'Western'}>Western</option>
        </select>
      </div>
      <div className="flex pr-4">
        <Pagination totalpages={Math.ceil(total / limit)} currentPage={parseInt(searchParams.get('page') || '1')} changePage={changePage} paginationDisabled={false} />
      </div>
    </div>
  </div>
}

export default HashtagPageFilters
